module.exports = __webpack_public_path__ + "img/imgUser.34601598.png";